export default "__VITE_ASSET__BNiYyVFz__"